import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import { appConstants } from "../_constants/app.constants";
import { useAuth } from "../auth/AuthContext";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  EmptyState,
  LoadingState,
  PageHeader,
  Toast,
  IconStar,
} from "../ui";

export default function MyFavoritesPage() {
  const { user, ready: authReady } = useAuth();
  const [favoriteTournaments, setFavoriteTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    if (!authReady || !user) {
      setFavoriteTournaments([]);
      setLoading(false);
      return;
    }

    const run = async () => {
      try {
        setLoading(true);
        setLoadError("");
        const res = await axios.get(`${appConstants.API_URL}/api/tournaments/favorites`);
        setFavoriteTournaments(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error(err);
        if (err.response?.status === 401) {
          setLoadError("Necesitas iniciar sesion para ver tus favoritos.");
        } else {
          setLoadError("No se pudieron cargar los favoritos.");
        }
        setFavoriteTournaments([]);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [authReady, user]);

  return (
    <div className="ui-page-wrap py-4 sm:py-6">
      <PageHeader
        title="Mis favoritos"
        subtitle="Torneos que sigues para acceder rapido al visor y al bracket."
      />

      {!user && authReady ? (
        <Toast kind="info" className="mt-5">
          Inicia sesion para ver los torneos que marques como favoritos.
        </Toast>
      ) : null}

      {!authReady || loading ? <LoadingState label="Cargando favoritos..." className="min-h-[26vh]" /> : null}

      {loadError && !loading && authReady ? <Toast kind="error" className="mt-6">{loadError}</Toast> : null}

      {authReady && !loading && !loadError && user && favoriteTournaments.length === 0 ? (
        <div className="mt-10">
          <EmptyState
            title="Aun no tienes favoritos"
            description="Abre un torneo y pulsa Seguir torneo para guardarlo aqui."
            action={
              <Button as={RouterLink} to="/" variant="gold">
                Explorar inicio
              </Button>
            }
          />
        </div>
      ) : null}

      {authReady && !loading && !loadError && user && favoriteTournaments.length > 0 ? (
        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {favoriteTournaments.map((f) => (
            <Card key={f.id} className="border-gold/15 shadow-card">
              <CardBody className="pb-3">
                <div className="flex items-start gap-2">
                  <IconStar className="mt-0.5 shrink-0 text-gold" size={18} />
                  <p className="font-bold text-ink">{f.name}</p>
                </div>
              </CardBody>
              <CardFooter className="pt-0">
                <div className="flex flex-wrap gap-2">
                  <Button as={RouterLink} to={`/viewer/${f.id}`} size="sm" variant="outline">
                    Visor
                  </Button>
                  <Button as={RouterLink} to={`/viewbracket/${f.id}`} size="sm" variant="outline">
                    Bracket
                  </Button>
                  <Button as={RouterLink} to={`/tournamentactions/${f.id}`} size="sm" variant="primary">
                    Gestion
                  </Button>
                </div>
              </CardFooter>
            </Card>
          ))}
        </div>
      ) : null}
    </div>
  );
}
